/**
 * @generated SignedSource<<b6a05ee6b94c5242dffa716143d1dc42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelatedPhotosGridTile_photo$data = {
  readonly height: number | null;
  readonly id: string;
  readonly name: string | null;
  readonly path: string | null;
  readonly photoLike: {
    readonly photoLikeId?: string | null;
    readonly totalPhotoLikes: number | null;
  } | null;
  readonly serviceId: string | null;
  readonly url: string | null;
  readonly width: number | null;
  readonly " $fragmentType": "RelatedPhotosGridTile_photo";
};
export type RelatedPhotosGridTile_photo$key = {
  readonly " $data"?: RelatedPhotosGridTile_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedPhotosGridTile_photo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelatedPhotosGridTile_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotoLike",
      "kind": "LinkedField",
      "name": "photoLike",
      "plural": false,
      "selections": [
        {
          "condition": "hasUserId",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "userId",
                  "variableName": "userId"
                }
              ],
              "kind": "ScalarField",
              "name": "photoLikeId",
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalPhotoLikes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};

(node as any).hash = "1c57fdb1ac4c184f7213c8f133403885";

export default node;
